module.exports = __webpack_public_path__ + "img/6.251e5560.png";